const formatCurrency = (value, includeUnit = true) => {
  if (typeof value !== "number")
    return null;
  let currencyFormat;
  if (includeUnit)
    currencyFormat = new Intl.NumberFormat("vi-VN", {
      style: "currency",
      currency: "VND"
    });
  else
    currencyFormat = new Intl.NumberFormat("vi-VN");
  return currencyFormat.format(value);
};

export { formatCurrency };
